import React, { useEffect, useRef, useState } from 'react';
import { Step } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';

const deepEqual = (arr1:any, arr2:any) => {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i].count !== arr2[i].count || arr1[i].service !== arr2[i].service) {
            return false;
        }
    }
    return true;
};

const StepL4ForOrders = () => {
  const [services, setServices] = useState([]);
  const { dashboardStore, activityStore } = useStore();
  const prevServiceCountRef = useRef<any[]>([]);

  const fetchData = async () => {
    try {
      await activityStore.HFCServiceCount();
      dashboardStore.dashboard.valueForL4Orders = activityStore.ServiceCount[0]?.service || '';
      setServices(activityStore.ServiceCount);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchData();
     // eslint-disable-next-line
  }, []);

  // Detect changes in ServiceCount
  useEffect(() => {
    if (!deepEqual(prevServiceCountRef.current, activityStore.ServiceCount)) {
      prevServiceCountRef.current = [...activityStore.ServiceCount];
      setServices(activityStore.ServiceCount);
    }
  }, [activityStore.ServiceCount]);

  return (
    <div style={{ marginTop: '-10px' }}>
      {services.length > 0 ? (
        <Step.Group size="tiny" widths={services.length as any}>
          {services.map((service:any, index:any) => (
            <Step
              key={index}
              style={{
                borderRight: '1px solid #F0F0F0',
                background: `linear-gradient(90deg, rgba(240,240,290,1) 40%, rgba(255,255,255,1) 50%)`,
              }}
              className={
                dashboardStore.dashboard.valueForL4Orders === service.service
                  ? 'orderlevel2dark'
                  : 'orderlevel2light'
              }
              onClick={() => dashboardStore.openL4ForOrders(service.service)}
            >
              <Step.Content>
                <Step.Title>
                  {service.service} ({service.count})
                </Step.Title>
              </Step.Content>
            </Step>
          ))}
        </Step.Group>
      ) : (
        <Step.Group size="tiny" widths={1}>
          <Step>
            <Step.Content>
              <Step.Title>No Active Services</Step.Title>
            </Step.Content>
          </Step>
        </Step.Group>
      )}
    </div>
  );
};

export default observer(StepL4ForOrders);
